import { FHIRExportSection } from "@/features/patient/security/components/FhirExportView";

export function FhirExportPage() {
  return <FHIRExportSection />;
}
